import ModalViewBenchmarkTemplate from "./modal-view-benchmark-template";

export default ModalViewBenchmarkTemplate;